import { DetailedSolution, Solution, TvMeteoAlert } from 'app/model/SOL49';
import { MeasureDto, MeasureId } from 'app/model/CORE';
import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { Select } from 'antd';
import 'app/components/panels/solver/CompareSolutionPanel.less';
import { MeasureImpactPanel } from './MeasureImpactPanel';

const { Option } = Select;

interface CompareSolutionProps {
    solutions: DetailedSolution[];
    meteoAlerts: { [key: string]: Array<TvMeteoAlert> };
    defaultSolution: number;
    outdatedSolutions: string[];
    onRemoveMeasure: (measure: MeasureDto, solutionIdx: number) => void;
    onShowTVsImpact?: () => void;
    onShowOtherTVsImpact?: () => void;
    onShowMeasuresImpact?: () => void;
    onMeasureEdited?: (measureId: MeasureId, solutionIdx: number, measure: MeasureDto) => void;
    onUpdateSolution?: (solution: Solution) => void;
    onApplySolution?: (solution: Solution) => void;
    onApplicableScenarios?: (applicableScenarios: Map<string, number>) => void;
    onShareSolution: (solution: DetailedSolution) => void;
}

interface CompareSolutionState {
    selectedSolution: number;
    selectedMeasure: MeasureDto;
}

export class CompareSolutionPanel extends PureComponent<CompareSolutionProps, CompareSolutionState> {
    constructor(props) {
        super(props);

        this.state = {
            selectedSolution: this.props.defaultSolution,
            selectedMeasure: this.props.solutions[this.props.defaultSolution].measures[0],
        };
    }

    handleSolutionChange = (selectedSolution: string) => {
        const newSolutionIdx = this.props.solutions.findIndex(s => s.name === selectedSolution);
        this.setState({
            selectedSolution: newSolutionIdx,
            selectedMeasure: this.props.solutions[newSolutionIdx].measures[0],
        });
    };

    render() {
        const solution = this.props.solutions[this.state.selectedSolution];

        return (
            <Flex grow={false} direction="vertical" className="compare-solution">
                <Select className="select-solution" defaultValue={solution.name} onChange={this.handleSolutionChange}>
                    {this.props.solutions.map(solution => (
                        <Option key={solution.name} value={solution.name}>
                            {solution.name}
                        </Option>
                    ))}
                </Select>
                <MeasureImpactPanel
                    solution={solution}
                    meteoAlerts={this.props.meteoAlerts}
                    solutionImpactOutdated={this.props.outdatedSolutions.includes(solution.name)}
                    onRemoveMeasure={measure => this.props.onRemoveMeasure(measure, this.state.selectedSolution)}
                    onMeasureEdited={(measureId, measure) =>
                        this.props.onMeasureEdited(measureId, this.state.selectedSolution, measure)
                    }
                    onShowTVsImpact={this.props.onShowTVsImpact}
                    onShowMeasuresImpact={this.props.onShowMeasuresImpact}
                    onUpdateSolution={this.props.onUpdateSolution}
                    onApplySolution={this.props.onApplySolution}
                    onApplicableScenarios={this.props.onApplicableScenarios}
                    onShareSolution={this.props.onShareSolution}
                />
            </Flex>
        );
    }
}
